import { Select } from '@chakra-ui/react';
import {
  QuoteEmailTemplate,
  quoteEmailTemplateMetadata,
  SiteCode,
} from '@snap-types/models/enums';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { UpdateTeamWithConfig } from '@snap-types/models/team';
import { objectKeysTyped } from '@snap-types/util/object-iterators';
import { useFormContext } from 'react-hook-form';

export function TeamQuoteEmailTemplateSelect({
  team,
  index,
}: {
  team: UpdateTeamWithConfig;
  index: number;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const emailTemplateOptions = objectKeysTyped(QuoteEmailTemplate)
    .map((emailTemplate) => {
      if (
        quoteEmailTemplateMetadata[emailTemplate].limitedToSites === null ||
        quoteEmailTemplateMetadata[emailTemplate].limitedToSites?.includes(
          form.getValues('site.code') as SiteCode,
        )
      ) {
        return {
          emailTemplate,
          ...quoteEmailTemplateMetadata[emailTemplate],
        };
      }
      return null;
    })
    .filter((emailTemplate) => emailTemplate !== null);

  return (
    <Select
      id={`${team.teamCode}-emailTemplate-select`}
      {...form.register(
        `site.teams.${index}.currentTeamConfig.quoteEmailTemplate`,
      )}
    >
      {emailTemplateOptions.map((emailTemplate) => (
        <option
          key={emailTemplate.emailTemplate}
          value={emailTemplate.emailTemplate}
        >
          {emailTemplate.name}
        </option>
      ))}
    </Select>
  );
}
